import React, {useState,useEffect} from "react";
import {
  IonItem,
  IonLabel,
  IonText,
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButtons,
  IonBackButton,
  IonInput,
  IonToast,
  IonIcon,
  IonImg
} from "@ionic/react";
import { MobXProviderContext } from "mobx-react";
import { copy } from 'ionicons/icons';
import { useParams } from "react-router";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { useHistory } from "react-router";
import * as firebase from "firebase";
import 'react-accessible-accordion/dist/fancy-example.css';
import ReactTimeAgo from 'react-time-ago'

const TabOneDetailPage = () => {

  const { store } = React.useContext(MobXProviderContext);
  const history = useHistory();
  const params = useParams();
  const [accountId, setAccountId] = useState(null);
  const [user_id, setUserId] = useState(null);
  const [accountData, setAccountData] = useState([]);
  const [search, setSearch] = useState([]);
  const [errorInfo, setErrorInfo] = useState({});

  let value = store.itemByKey(params.id);
  useEffect(() => {
    setAccountId(window.localStorage.getItem('account_id'));
    setUserId(window.localStorage.getItem('userid'));
    return loadHistory();
  }, [history.location]);

  const loadHistory = () =>{
    if(window.localStorage.getItem('account_id')==null || window.localStorage.getItem('account_id')==undefined || window.localStorage.getItem('account_id')==''){
      if (history.location.pathname=='/tabs/time') {
        return history.replace("/tabs/settings");
      }
    }
    else{
      let adata = [];
      firebase.firestore().collection('history').doc(window.localStorage.getItem('account_id')).collection('data').orderBy('date', 'desc').get().then(results => {
        results.docs.forEach(d=>{
          adata.push(d.data());
        });
        setAccountData(adata);
        console.log(adata)
      });
    }
  }
  const copyText = (text) =>{
    navigator.clipboard.writeText(text);
    setErrorInfo({showErrorToast:true,errMsg:'Copied!'});
  }

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="logo"><IonImg src="/assets/img/logo.png" alt="Logo"></IonImg></div>
        <IonText style={{'textAlign':'center'}}><h4>History</h4></IonText>
        {/*<IonInput
            type="text"
            onIonChange={(e) => {
              setSearch(e.detail.value);
            }}
            name="user_id"
            value={search} className="searchbox"
            placeholder="Search..."
          />*/}
        <Accordion allowZeroExpanded={true}>
            {accountData.map(function(d, idx){
                 return (<AccordionItem key={'m'+idx}>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        {d.ruser_id.replace('U','')} {d.ruser_name!=null?'('+d.ruser_name.substring(0,8)+')':''} <ReactTimeAgo date={new Date(d.date.seconds*1000)}/>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="messages">
                    {d.messages.map(function(d1, idx1){
                      return (<div key={'m'+idx1} className={user_id==d1.from?'from':'to'}>{d1.message}{d1.from==user_id?null:(<IonIcon icon={copy} onClick={() => copyText(d1.message)}
></IonIcon>) }</div>)
                    })}
                  </div>
                </AccordionItemPanel>
            </AccordionItem>)
            })}
        </Accordion>
        <IonToast
          color="dark"
          isOpen={errorInfo.showErrorToast}
          onDidDismiss={() => setErrorInfo({ showErrorToast: false })}
          message={errorInfo.errMsg}
          position="middle"
          duration={2000}
        />
      </IonContent>
    </IonPage>
  );
};

export default TabOneDetailPage;